import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { inject } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CustomTitleStrategy extends TitleStrategy {
  
  private title = inject(Title);
  
  constructor() {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    let title = this.buildTitle(routerState);
    
    let route = routerState.root;
    let moduleName = '';
    let params: { [key: string]: string } = {};
    let dataTitle = '';
    
    while (route.firstChild) {
      route = route.firstChild;
      if (route.data) {
        if (route.data['module']) {
          moduleName = route.data['module'];
        }
        if (route.data['title']) {
          dataTitle = route.data['title'];
        }
      }
      params = { ...params, ...route.params };
    }
    
    if (!title && dataTitle) {
      title = dataTitle;
    }
    
    if (title) {
      // Dynamic replacements for Contact Type
      if (title.includes('[Contact Type]')) {
        const typeCode = params['contact-type-code'];
        const typeName = this.formatContactType(typeCode);
        title = title.replace('[Contact Type]', typeName);
      }
      
      // Dynamic replacements for Order Element
      if (title.includes('[Order Element]')) {
        const orderElement = params['orderElement'];
        const elementName = this.formatOrderElement(orderElement);
        title = title.replace('[Order Element]', elementName);
      }
      
      // Dynamic replacements for Workgroup
      if (title.includes('[Workgroup]')) {
        const workgroup = params['workgroup'];
        const groupName = this.formatWorkgroup(workgroup);
        title = title.replace('[Workgroup]', groupName);
      }

      // Dynamic replacements for ID
      if (title.includes('[ID]')) {
        const id = params['id'];
        if (id) {
          title = title.replace('[ID]', `#${id}`);
        } else {
          title = title.replace(' #[ID]', '').replace(' [ID]', '').replace('[ID]', '');
        }
      }

      const moduleSuffix = moduleName ? ` | ${moduleName}` : '';
      this.title.setTitle(`${title}${moduleSuffix} | Mavles ERP`);
    } else {
      this.title.setTitle('Mavles ERP');
    }
  }

  private formatContactType(code: string): string {
    if (!code) return 'Contact';
    switch (code.toLowerCase()) {
      case 'customer': return 'Customer';
      case 'vendor': return 'Vendor';
      case 'labour': return 'Labourer';
      case 'builder': return 'Builder';
      case 'labour-group': return 'Labour Group';
      case 'employee': return 'Employee';
      default: return code.charAt(0).toUpperCase() + code.slice(1);
    }
  }

  private formatOrderElement(element: string): string {
    if (!element) return 'Order';
    switch (element.toLowerCase()) {
      case 'estimate': return 'Quotation';
      case 'order': return 'Sales Order';
      default: return element.charAt(0).toUpperCase() + element.slice(1);
    }
  }

  private formatWorkgroup(group: string): string {
    if (!group) return 'Work';
    switch (group.toLowerCase()) {
      case 'labour-group': return 'Labour Group';
      default: return group.charAt(0).toUpperCase() + group.slice(1);
    }
  }
}
